import { defineMessages } from 'react-intl'

export default defineMessages({
  btn: 'Learn more'
})
